import angular from 'angular';
import lbaRadioDir from './lbaRadioDir';
import lbaRadioCtrl from './lbaRadioCtrl';

export default angular
  .module('lbaRadio', [])
  .directive('lbaRadio', lbaRadioDir)
  .controller('lbaRadioCtrl', lbaRadioCtrl);


// WEBPACK FOOTER //
// ./src/components/lbaRadio/index.js